// components/industry-templates/FilmEventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Film, Star, Award, Calendar } from 'lucide-react';

export const FilmEventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      <Card className="border-0 bg-gradient-to-br from-purple-600/20 to-pink-600/20 backdrop-blur">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2 text-2xl">
            <Film className="w-8 h-8" style={{ color: theme.primary }} />
            Film Screenings
            </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {industryData?.films?.map((film: any, idx: number) => (
              <div key={idx} className="p-5 bg-white/10 rounded-xl border border-white/20">
                <div className="flex justify-between items-start mb-3">
                  <div>
                    <h3 className="text-2xl font-bold text-white mb-1">{film.title}</h3>
                    <p className="text-slate-300">{film.director}</p>
                  </div>
                  {film.premiere && (
                    <Badge className="bg-yellow-500 text-black">PREMIERE</Badge>
                  )}
                </div>
                <div className="flex gap-3 flex-wrap">
                  <Badge style={{ backgroundColor: theme.primary }}>{film.genre}</Badge>
                  <Badge variant="outline" className="border-white/20 text-white">{film.duration}</Badge>
                  <Badge variant="outline" className="border-white/20 text-white">{film.language}</Badge>
                </div>
                {film.screening_time && (
                  <p className="text-sm text-slate-400 mt-3">
                    <Calendar className="w-4 h-4 inline mr-1" />
                    {film.screening_time}
                  </p>
                )}
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      {industryData?.awards && (
        <Card className="border-2" style={{ borderColor: theme.primary }}>
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <Award className="w-6 h-6" style={{ color: theme.primary }} />
              Film Awards
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
              {industryData.awards.categories?.map((category: string, idx: number) => (
                <div key={idx} className="p-4 bg-white/5 rounded-lg text-center">
                  <div className="text-2xl mb-2">🏆</div>
                  <p className="text-white font-medium text-sm">{category}</p>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {industryData?.special_guests && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <Star className="w-6 h-6" style={{ color: theme.primary }} />
              Special Guests & Q&A
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              {industryData.special_guests.map((guest: any, idx: number) => (
                <div key={idx} className="p-4 bg-white/5 rounded-lg flex items-center gap-4">
                  <div className="text-3xl">🎬</div>
                  <div className="flex-1">
                    <h4 className="font-bold text-white">{guest.name}</h4>
                    <p className="text-sm text-slate-400">{guest.role}</p>
                  </div>
                  {guest.qna_session && (
                    <Badge style={{ backgroundColor: theme.primary }}>Q&A Session</Badge>
                  )}
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
